const resources = {
  "en": {
    "resetPassword": {
      "title": "🔐 Choose New Password",
      "passwordLabel": "New password",
      "confirmPasswordLabel": "Confirm password",
      "submit": "Change password",
      "success": "Password updated. You can now log in.",
      "invalidLink": "Invalid link",
      "passwordMismatch": "Passwords do not match"
    }
  },
  "uk": {
    "resetPassword": {
      "title": "🔐 Оберіть новий пароль",
      "passwordLabel": "Новий пароль",
      "confirmPasswordLabel": "Підтвердіть пароль",
      "submit": "Змінити пароль",
      "success": "Пароль оновлено. Тепер можна увійти.",
      "invalidLink": "Недійсне посилання",
      "passwordMismatch": "Паролі не збігаються"
    }
  }
};

export default resources;
